import { isAxiosError } from 'axios'
import { ApiError } from '@/api/http/types'
import { isNetworkApiError } from '@/shared/lib/apiErrorMessages'

/** Local dev — wizard step 1/2 when AI HTTP is down or misconfigured. */
export const CAMPAIGN_AI_DEV_UNAVAILABLE_HINT =
  'AI service is unavailable. Start brushfire-ai-service on port 4004 (`uvicorn main:app --reload --port 4004` in that repo), ensure AI_SERVICE_URL=http://localhost:4004 in campaign-service `.env`, then retry.'

/** Local dev — connectivity / offline during wizard AI steps. */
export const CAMPAIGN_AI_DEV_CONNECTIVITY_HINT =
  'Campaign analysis could not complete. Ensure brushfire-ai-service is on port 4004 (`uvicorn main:app --reload --port 4004`), brushfire-campaign-service on :4001 (`pnpm dev`), and Sensemaker on :3000 (`pnpm dev`). Analysis can take 1–2 minutes.'

/** Shown when launch fails due to connectivity (no response / network_error). */
export const CAMPAIGN_LAUNCH_NETWORK_ERROR_MESSAGE =
  'Campaign could not be launched. Please try again.'

/** Shown when wizard AI generation (step 1 / step 2) fails or connectivity is lost. */
export const CAMPAIGN_AI_ANALYSIS_FAILED_MESSAGE =
  'AI analysis failed. Please try again.'

const DEV_BACKEND_HINT =
  'Cannot reach the API. Ensure brushfire-campaign-service is running on port 4001 (`pnpm dev` in that repo), then retry.'

export function messageFromUnknownApiError(
  e: unknown,
  fallback: string,
): string {
  if (e instanceof ApiError) {
    if (import.meta.env.DEV && e.code === 'network_error') {
      return DEV_BACKEND_HINT
    }
    return e.message
  }
  if (isAxiosError(e)) {
    const body = e.response?.data as { message?: string } | undefined
    const fromBody = body?.message
    if (typeof fromBody === 'string' && fromBody.length > 0) {
      return fromBody
    }
    return e.message || fallback
  }
  return fallback
}

export { messageFromCampaignAiStepError } from './campaignAiStepErrorMessages'

/** User-facing message for Team & Launch — network vs API/body errors. */
export function messageFromCampaignLaunchError(e: unknown): string {
  if (isNetworkApiError(e)) {
    return CAMPAIGN_LAUNCH_NETWORK_ERROR_MESSAGE
  }
  return messageFromUnknownApiError(e, CAMPAIGN_LAUNCH_NETWORK_ERROR_MESSAGE)
}
